import { useEffect, useState } from 'react';
import { useDixaMessengerApi } from 'components/settings/components/sections/dixaMessenger/api/apiProvider';
import { messengerLanguages } from '../../../appearance/components/generalSettings/languageSettings/languages';
import { getCompanySettingsQuery, } from '../../components/shared/knowledgeBaseLinkPreview/api';
import { useElevioQuery } from './useElevioQuery';
const elevioSettingsQueryVars = {};
export function useQueryElevioIntegration(messengerId) {
    const [elevioIntegration, setElevioIntegration] = useState();
    const messengerApi = useDixaMessengerApi();
    useEffect(() => {
        if (!messengerId)
            return;
        messengerApi
            .fetch(messengerId)
            .then((messenger) => {
            setElevioIntegration({
                companyId: extractElevioCompanyId(messenger.settings),
                availableLocales: extractAvailableLocales(messenger.settings),
            });
        })
            .catch((_) => {
            setElevioIntegration(undefined);
        });
    }, [messengerApi, messengerId]);
    const { data } = useElevioQuery({
        query: getCompanySettingsQuery,
        variables: elevioSettingsQueryVars,
        companyId: elevioIntegration === null || elevioIntegration === void 0 ? void 0 : elevioIntegration.companyId,
    });
    return !elevioIntegration || !data
        ? undefined
        : Object.assign(Object.assign({}, elevioIntegration), data.companySettings);
}
function extractAvailableLocales(settings) {
    var _a, _b;
    return ((_b = (_a = settings === null || settings === void 0 ? void 0 : settings.general) === null || _a === void 0 ? void 0 : _a.availableLocales.map((locale) => {
        var _a, _b;
        return ({
            code: locale,
            label: (_b = (_a = messengerLanguages.find(({ code }) => code === locale)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : locale,
        });
    })) !== null && _b !== void 0 ? _b : []);
}
function extractElevioCompanyId(settings) {
    var _a, _b, _c, _d;
    return ((_b = (_a = settings === null || settings === void 0 ? void 0 : settings.integrations) === null || _a === void 0 ? void 0 : _a.elevio) === null || _b === void 0 ? void 0 : _b.enabled) === true
        ? (_d = (_c = settings === null || settings === void 0 ? void 0 : settings.integrations) === null || _c === void 0 ? void 0 : _c.elevio) === null || _d === void 0 ? void 0 : _d.companyId
        : undefined;
}
